export enum QuoteTheme {
  WHITE = 'WHITE',
  BROWN = 'BROWN',
}
